import { Action } from "./Actions";

export const trialAccountAllowedActions = {
  disabledActions: [Action.DeleteCard, Action.AddCard, Action.AddPlatformVideo],
};
